var React = require('react');
import { Link, browserHistory } from 'react-router';
var PropTypes = React.PropTypes;
var Auth = require("../../resources/auth");

import CircularProgress from 'material-ui/CircularProgress';
// import RaisedButton from 'material-ui/RaisedButton';
import '../../css/components/Students/students.css';
// import { Pager } from 'react-bootstrap';

// import StudentsTable from './StudentsTable';
var StudentRes = require('../../resources/student');

const STUDENT_STATUSES = [{
  // title: 'Draft',
  // code: 'draft',
  // value: ['self'],
  // actions: ['edit', 'delete'],
  // count: '-',
  cols: ['firstName', 'lastName', 'email', 'phone', 'residentialAddress', 'schoolName', 'class', 'SA2Grade', 'parentName' ,'parentNo', 'parentEmail', 'lastActivityDate'],
  notes: [
    ''
  ]
}];

const ITEM_LIMIT = 20;
var ViewStudent = React.createClass({
  componentWillReceiveProps: function(nextProps) {
    this.setState({})
  },
  onSortChange: function(newSort) {
    // this.setState({
    //   sort: newSort,
    //   studentsData: [],
    //   isLoading: true,
    //   currentPager: 1,
    // }, () => {
    //   this.retrieveStudents();
    // });
  },
  getInitialState: function() {
    return {
        _id: '',
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        residentialAddress: '',
        schoolName: '',
        schoolClassName: '',
        SA2Grade: '',
        parentName: '',
        parentNo: '',
        parentEmail: '',
        lastActivityDate: '',
        statusMode: [],
        currentMode: {},
        isLoading: true,
      // conceptsMap: null,
    };
  },
  handleChangeData: function(e) {
    // var update = {};
    // update[field] = e.target.value;
    // this.setState(update);
    // var searchName = this.state.searchStudentName;
    // this.setState({
    //   searchStudentName: e.target.value,
    //   studentsData: [],
    //   isLoading: true,
    //   currentPager: 1,
    //   sort: 'firstName'
    // }, () => {
    //   this.retrieveStudents(this.state.searchStudentName,this.state.searchStudentName);
    // });
  },
  submit: function() {
    // var _this = this;
    // var oldPassword = _this.state.currentPassword;
    // var newPassword = _this.state.newPassword;
    // var confirmPassword = _this.state.confirmPassword;
    // if (!oldPassword || !newPassword || !confirmPassword) return alert('Please input all fields');
    // if (newPassword !== confirmPassword) return alert('New password not match');
    // _this.setState({
    //   isLoading: true
    // })
    // Auth.changePassword({
    //   "oldPassword": oldPassword,
    //   "newPassword": newPassword
    // }, function(err, res) {
    //   _this.setState({
    //     isLoading: false
    //   })
    //   if (err && err.response && err.response.text === 'WRONG_PASSWORD') return alert('Wrong password');
    //   if (err) return alert('Error occurred. Please try again later');
    //   alert('Change password success');
    // })
  },
  componentDidMount: function() {

    var _this = this;
    var statusMode = this.state.statusMode;
    statusMode = STUDENT_STATUSES;
    var currentUser = Auth.getCurrentUser();

    var currentURL = window.location.href;
    currentURL = currentURL.split("/");
    var studentID = currentURL[currentURL.length-1]; //get the current class ID
    
    // if (currentUser.status.indexOf('reviewer') >= 0) return browserHistory.push('/review-tasks');
    // if (currentUser.role === 'admin') {
    //   statusMode = ADMIN_STATUSES;
    // } else  {
    //   statusMode = TEACHER_STATUSES;
    // }
    var currentMode = statusMode[0];
    if (this.props.location.query.mode) {
      var mode = this.props.location.query.mode,
          mappedMode = statusMode.filter((value) => {
            return value.code === mode
          })[0];
      if (mappedMode) currentMode = mappedMode;
    }
    this.setState({
        _id: studentID,
        isLoading: true,
        statusMode: statusMode,
        currentMode: currentMode
    }, function() {
      // var count = statusMode.length;
      // for (var i = 0; i < statusMode.length; i++) {
      //   this.countCollectionInMode(statusMode[i], function() {
      //     count--;
      //     if (count <= 0) _this.forceUpdate();
      //   });
      // }
      this.retrieveStudent();
    });
  },
  retrieveStudent: function(fName,lName,callback) {
    callback = callback || function(){};
    var _this = this;
    var currentPager = this.state.currentPager;
    var options = {};
    options.skip = ITEM_LIMIT * (currentPager - 1);
    options.limit = ITEM_LIMIT;
    // options.sort = this.state.sort || "dateCreated";
    options.conditions = {};
    // options.conditions.status = {
    //   "$in": this.state.currentMode.value
    // }
    // if (!this.state.currentMode.canApplyAdminRole) {
    //   options.conditions.creator = Auth.getCurrentUser()._id;
    // }
    // if (this.state.currentMode.include) {
    //   options.include = this.state.currentMode.include;
    //   options.includeConditions = includeConditions[options.include];
    // }
          // console.log("state of mdoe is " + this.state.currentMode.cols);
    
    // var currentURL = window.location.href;
    // currentURL = currentURL.split("/");
    var studentID = this.state._id;//currentURL[currentURL.length-1]; //get the current class ID

    options.conditions.sort = this.state.sort || "firstName";
    // options.conditions.status = 'student';
    options.conditions.studentID = studentID;

    // var firstN = '';
    // var lastN = '';
    // if (fName) { firstN = fName; }
    // if (lName) { lastN = lName; }

    // options.conditions.sort = this.state.sort || "dateCreated";
    options.conditions.status = 'student';
    // options.conditions.firstName = firstN;
    // options.conditions.lastName = lastN;
    StudentRes.retrieveStudent(options, function(err, res) {
      // console.log("BEFORE DON sdfdsfsE!!");
      // if (callback) return callback(err, res);

      console.log("RES IS :" + res.lastName);


        _this.setState({
            _id: studentID,
            isLoading: false,
            firstName: res.firstName,
            lastName: res.lastName,
            email: res.email,
            phone: res.phone,
            residentialAddress: res.metadata.residentialAddress,
            schoolName: res.metadata.school,
            schoolClassName: res.metadata.class,
            SA2Grade: res.metadata.SA2Grade,
            parentName: res.metadata.parentName,
            parentNo: res.metadata.parentNo,
            parentEmail: res.metadata.parentEmail,
            lastActivityDate: '',
            // studentsData: (!err && res) ? res: [{}]
            }, () => {

                // var sData = _this.state.studentsData;
                // for (var i = 0; i < sData.length; i++) {

                //     var thisData = sData[i];
                //     var dDate = thisData['lastActivityDate'];
                //     var processDate = new Date(dDate);
                //     var dateToDisplay = processDate.toDateString();
                //     if (processDate.getFullYear()=='1970') { dateToDisplay = '-';}
                //     thisData['lastActivityDate'] = dateToDisplay;//processDate.getFullYear() + "/" + processDate.getMonth() + "/" + processDate.getDate();
                // }

                // _this.setState({
                //     studentsData: sData
                // });
            // console.log("DONE!!!");
            }
        );
    })
  },
  navigatePager: function(dir) {
    var currentPager = this.state.currentPager,
              _this  =  this;
    currentPager += dir;
    _this.setState({
      currentPager: currentPager,
      isLoading: true
    }, function() {
      this.retrieveStudents(this.state.searchStudentName,this.state.searchStudentName);
      // this.retrieveStudents(function(err, res) {
      // })
    })
  },
  render: function() {
    var _this = this;
    return (
        <div className="students">
            
            <div className="row createStudentRow">
                <div className="col col-md-2 DivlblCreateStudent">
                    <label className="lblCreateStudent"></label>
                </div>
                <div className="col col-md-10 DivTxtCreateStudent">
                    <label className="lblStudentInfo"><h3> {_this.state.firstName} {_this.state.lastName} </h3></label>
                </div>
            </div>
            <hr/>
            <div className="row createStudentRow">
                <div className="col col-md-2 DivlblCreateStudent">
                    <label className="lblCreateStudent">Email</label>
                </div>
                <div className="col col-md-10 DivTxtCreateStudent">
                    <label className="lblStudentInfo">{_this.state.email}</label>
                </div>
            </div>
            <br/>
            <div className="row">
                <div className="col col-md-2 DivlblCreateStudent">
                <label className="lblCreateStudent">Mobile Number</label>
                </div>
                <div className="col col-md-10 DivTxtCreateStudent">
                    <label className="lblStudentInfo">{_this.state.phone}</label>
                </div>
            </div>
            <br/>
            <div className="row">
                <div className="col col-md-2 DivlblCreateStudent">
                <label className="lblCreateStudent">Residential Address</label>
                </div>
                <div className="col col-md-10 DivTxtCreateStudent">
                    <label className="lblStudentInfo">{_this.state.residentialAddress}</label>
                </div>
            </div>
            <br/>
            <div className="row">
                <div className="col col-md-2 DivlblCreateStudent">
                <label className="lblCreateStudent">School Name</label>
                </div>
                <div className="col col-md-10 DivTxtCreateStudent">
                    <label className="lblStudentInfo">{_this.state.schoolName}</label>
                </div>
            </div>
            <br/>
            <div className="row">
                <div className="col col-md-2 DivlblCreateStudent">
                <label className="lblCreateStudent">Class</label>
                </div>
                <div className="col col-md-10 DivTxtCreateStudent">
                    <label className="lblStudentInfo">{_this.state.schoolClassName}</label>
                </div>
            </div>
            <br/>
            <div className="row">
                <div className="col col-md-2 DivlblCreateStudent">
                <label className="lblCreateStudent">Latest SA1/2 Grade</label>
                </div>
                <div className="col col-md-10 DivTxtCreateStudent">
                    <label className="lblStudentInfo">{_this.state.SA2Grade}</label>
                </div>
            </div>
            <br/>
            <div className="row">
                <div className="col col-md-2 DivlblCreateStudent">
                <label className="lblCreateStudent">Parent's Name</label>
                </div>
                <div className="col col-md-10 DivTxtCreateStudent">
                    <label className="lblStudentInfo">{_this.state.parentName}</label>
                </div>
            </div>
            <br/>
            <div className="row">
                <div className="col col-md-2 DivlblCreateStudent">
                <label className="lblCreateStudent">Parent's Telephone</label>
                </div>
                <div className="col col-md-10 DivTxtCreateStudent">
                    <label className="lblStudentInfo">{_this.state.parentNo}</label>
                </div>
            </div>
            <br/>
            <div className="row">
                <div className="col col-md-2 DivlblCreateStudent">
                <label className="lblCreateStudent">Parent's Email</label>
                </div>
                <div className="col col-md-10 DivTxtCreateStudent">
                    <label className="lblStudentInfo">{_this.state.parentEmail}</label>
                </div>
            </div>
            <br/><br/>
        </div>
    );
  }

});

module.exports = ViewStudent;



/** WEBPACK FOOTER **
 ** ./src/components/Students/ViewStudent.js
 **/